export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-34d310cf7d5b000fd9437b4989eacec2.png";